var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "trp-editor" } }, [
    _c(
      "div",
      { attrs: { id: "trp-controls" } },
      [
        _c(
          "div",
          { staticClass: "trp-controls-container" },
          [
            _c("div", { attrs: { id: "trp-close-save" } }, [
              _c("a", {
                attrs: {
                  id: "trp-controls-close",
                  href: _vm.closeURL,
                  title: _vm.editorStrings.close
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                { attrs: { id: "trp-save-and-loader-spinner" } },
                [
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.loading_strings > 0,
                          expression: "loading_strings > 0"
                        }
                      ],
                      staticClass: "trp-ajax-loader",
                      attrs: { id: "trp-string-saved-ajax-loader" }
                    },
                    [_c("div", { staticClass: "trp-spinner" })]
                  ),
                  _vm._v(" "),
                  _c("save-translations", {
                    attrs: {
                      selectedIndexesArray: _vm.selectedIndexesArray,
                      dictionary: _vm.dictionary,
                      settings: _vm.settings,
                      nonces: _vm.nonces,
                      ajax_url: _vm.ajax_url,
                      currentLanguage: _vm.currentLanguage,
                      onScreenLanguage: _vm.onScreenLanguage,
                      iframe: _vm.iframe,
                      currentURL: _vm.currentURL,
                      mergingString: _vm.mergingString,
                      mergeData: _vm.mergeData,
                      editorStrings: _vm.editorStrings
                    },
                    on: {
                      "translations-saved": function($event) {
                        _vm.showChangesUnsavedMessage = false
                      }
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "trp-controls-section" }, [
              _c("div", { staticClass: "trp-controls-section-content" }, [
                _c("div", { attrs: { id: "trp-language-switch" } }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.currentLanguage,
                          expression: "currentLanguage"
                        },
                        { name: "select2", rawName: "v-select2" }
                      ],
                      attrs: { id: "trp-language-select", name: "lang" },
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.currentLanguage = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        }
                      }
                    },
                    _vm._l(_vm.languageNames, function(lang, langIndex) {
                      return _c("option", { domProps: { value: langIndex } }, [
                        _vm._v(_vm._s(lang))
                      ])
                    }),
                    0
                  )
                ]),
                _vm._v(" "),
                _c("div", { attrs: { id: "trp-string-list" } }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.selectedString,
                          expression: "selectedString"
                        },
                        { name: "select2", rawName: "v-select2" }
                      ],
                      attrs: { id: "trp-string-categories" },
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.selectedString = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        }
                      }
                    },
                    _vm._l(_vm.stringGroups, function(group) {
                      return _c(
                        "optgroup",
                        { attrs: { label: group } },
                        _vm._l(_vm.dictionary, function(string, index) {
                          return _vm.showString(string, group)
                            ? _c(
                                "option",
                                {
                                  attrs: {
                                    title: string.description,
                                    "data-database-id": string.dbID,
                                    "data-group": string.group
                                  },
                                  domProps: { value: index }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.processOptionName(
                                        string.original,
                                        group
                                      )
                                    )
                                  )
                                ]
                              )
                            : _vm._e()
                        }),
                        0
                      )
                    }),
                    0
                  )
                ]),
                _vm._v(" "),
                _c("div", { attrs: { id: "trp-next-previous" } }, [
                  _c(
                    "button",
                    {
                      staticClass: "trp-next-previous-buttons",
                      attrs: {
                        type: "button",
                        id: "trp-previous",
                        title: _vm.editorStrings.previous_title_attr
                      },
                      on: {
                        click: function($event) {
                          _vm.previousString()
                        }
                      }
                    },
                    [
                      _c("span", [_vm._v("«")]),
                      _vm._v(" " + _vm._s(_vm.editorStrings.previous))
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "trp-next-previous-buttons",
                      attrs: {
                        type: "button",
                        id: "trp-next",
                        title: _vm.editorStrings.next_title_attr
                      },
                      on: {
                        click: function($event) {
                          _vm.nextString()
                        }
                      }
                    },
                    [
                      _vm._v(_vm._s(_vm.editorStrings.next) + " "),
                      _c("span", [_vm._v("»")])
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { attrs: { id: "trp-view-as" } }, [
                  _c("div", { attrs: { id: "trp-view-as-description" } }, [
                    _vm._v(_vm._s(_vm.editorStrings.view_as))
                  ]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.viewAs,
                          expression: "viewAs"
                        },
                        { name: "select2", rawName: "v-select2" }
                      ],
                      attrs: { id: "trp-view-as-select" },
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.viewAs = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        }
                      }
                    },
                    _vm._l(_vm.roles, function(role, roleIndex) {
                      return _c(
                        "option",
                        {
                          attrs: {
                            disabled: !role,
                            title: !role ? _vm.editorStrings.view_as_pro : ""
                          },
                          domProps: { value: role }
                        },
                        [_vm._v(_vm._s(roleIndex))]
                      )
                    }),
                    0
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.selectedString !== null,
                    expression: "selectedString !== null"
                  }
                ],
                staticClass: "trp-controls-section"
              },
              [
                _c("language-boxes", {
                  attrs: {
                    selectedIndexesArray: _vm.selectedIndexesArray,
                    dictionary: _vm.dictionary,
                    currentLanguage: _vm.currentLanguage,
                    onScreenLanguage: _vm.onScreenLanguage,
                    languageNames: _vm.languageNames,
                    settings: _vm.settings,
                    showChangesUnsavedMessage: _vm.showChangesUnsavedMessage,
                    editorStrings: _vm.editorStrings,
                    flagsPath: _vm.flagsPath,
                    iframe: _vm.iframe,
                    nonces: _vm.nonces,
                    ajax_url: _vm.ajax_url
                  },
                  on: {
                    "discarded-changes": function($event) {
                      _vm.hasUnsavedChanges()
                    }
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("extra-content", {
              attrs: {
                languageNames: _vm.languageNames,
                editorStrings: _vm.editorStrings,
                paidVersion: _vm.paid_version
              }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.translationNotLoadedYet,
                    expression: "translationNotLoadedYet"
                  }
                ],
                staticClass: "trp-controls-section"
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "trp-controls-section-content",
                    attrs: { id: "trp-translation-not-ready-section" }
                  },
                  [
                    _c("p", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.editorStrings.translation_not_loaded_yet
                        )
                      }
                    })
                  ]
                )
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { attrs: { id: "trp_select2_overlay" } }),
        _vm._v(" "),
        _c("hover-actions", {
          ref: "hoverActions",
          attrs: {
            dictionary: _vm.dictionary,
            settings: _vm.settings,
            iframe: _vm.iframe,
            dataAttributes: _vm.dataAttributes,
            mergeRules: _vm.mergeRules,
            nonces: _vm.nonces,
            ajax_url: _vm.ajax_url,
            mergeData: _vm.mergeData,
            editorStrings: _vm.editorStrings,
            currentLanguage: _vm.currentLanguage
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { attrs: { id: "trp-preview" } }, [
      _c("iframe", {
        attrs: { id: "trp-preview-iframe", src: _vm.urlToLoad },
        on: { load: _vm.iFrameLoaded }
      }),
      _vm._v(" "),
      _c("div", { attrs: { id: "trp-preview-loader" } }, [
        _c(
          "svg",
          {
            staticClass: "trp-loader",
            attrs: {
              width: "65px",
              height: "65px",
              viewBox: "0 0 66 66",
              xmlns: "http://www.w3.org/2000/svg"
            }
          },
          [
            _c("circle", {
              staticClass: "trp-circle",
              attrs: {
                fill: "none",
                "stroke-width": "6",
                "stroke-linecap": "round",
                cx: "33",
                cy: "33",
                r: "30"
              }
            })
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }